import api from "api";

const denunciations = {
    // Alimenta o dropdown de motivos. Os rótulos vêm da API para não duplicar
    // aqui a lista que o back-end valida.
    getReasons: () => {
        return api().get('/denunciations/reasons')
    },

    // Aceita denúncia de quem está logado e de quem não está: o token entra
    // sozinho quando existe, e o back-end grava o user_id só nesse caso.
    // Vai como multipart porque a denúncia pode levar imagens anexadas.
    create: (payload) => {
        return api().post('/denunciations', payload, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }
};

export default denunciations;
